import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, message } from "antd";
import TestimonialService from "../../../services/TestimonialService";
import "./style.scss";
import { UploadOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import Dragger from "antd/lib/upload/Dragger";

const { TextArea } = Input;

export default function AddTestimonial({
  updatedTestimonial,
  isEdit,
  closeModal,
  onAddorUpdate,
  modalOpen,
}) {
  const formRef = React.createRef();
  const [form] = Form.useForm();
  const [file, setFile] = useState("");
  const [previewFile, setPreviewFile] = useState();

  const adminRestaurant = useSelector((state) => state.admin);

  useEffect(() => {
    if (isEdit) {
      formRef.current.setFieldsValue({
        customer_name: updatedTestimonial.customer_name,
        description: updatedTestimonial.description,
      });
      setPreviewFile(updatedTestimonial.customer_photo);
      setFile(updatedTestimonial.customer_photo);
    }
  }, [formRef, isEdit, updatedTestimonial]);

  const submitFile = async (info) => {
    const formData = new FormData();
    formData.append("file", info.file.originFileObj);

    const data = await TestimonialService.uploadPhoto(formData);
    if (data) {
      setFile(data.url);
    }
  };
  const addAdmin = async (values) => {
    const testimonials = {
      restaurant_id: adminRestaurant,
      customer_name: values.customer_name,
      customer_photo: file,
      description: values.description,
      testimonial_date: new Date(),
      customer_since: new Date()
    };

    if (isEdit) {
      await TestimonialService.updateTestimonial(
        testimonials,
        updatedTestimonial && updatedTestimonial.id
      );
      message.success("Updated Successfully");
    } else {
     const data =  await TestimonialService.addTestimonial(testimonials);
     if(data)
      message.success("Added Successfully");
      else
      message.error(data?.msg ?? "Something went wrong, please try after some time")
    }
    onAddorUpdate();
  };

  return (
    <Modal
      title={isEdit ? "Update Testimonial" : "Add Testimonial"}
      open={modalOpen}
      footer={null}
      onCancel={() => closeModal()}
    >
      <Form ref={formRef} form={form} onFinish={addAdmin} layout="vertical">
        <Form.Item
          name="customer_name"
          label="Customer name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="description"
          label="Description"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <TextArea rows={4} />
        </Form.Item>
        <div>Upload Profile</div>
        {previewFile ? (
          <div>
            {" "}
            <img src={previewFile} alt="profile" />{" "}
            <Button onClick={() => setPreviewFile()}>Change Profile pic</Button>{" "}
          </div>
        ) : (
          <Dragger
            onChange={submitFile}
            maxCount={1}
            style={{ marginBottom: "10px" }}
          >
            <p className="ant-upload-drag-icon">
              <UploadOutlined />
            </p>
            <p className="ant-upload-text">
              Click or drag image file to this area to upload
            </p>
            <p className="ant-upload-hint">Please upload image files</p>
          </Dragger>
        )}

        <Form.Item className="button-form">
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
